// List state Mixin

const ListStateMixin = listName => ({
  mounted() {
    this.refreshListState();
  },
  computed: {
    listState() {
      return {
        selectedCategory: this.selectedCategory,
        currentPage: this.currentPage,
        perPage: this.perPage,
      }
    }
  },
  methods: {
    refreshListState() {
      const listStates = JSON.parse(sessionStorage.getItem(listName)) || []
      if (!listStates[window.category_id]) {
        sessionStorage.setItem(listName, JSON.stringify(
          {
            ...listStates,
            [window.category_id]: this.listState
          }
        ));
      }
      else {
        for (const property in listStates[window.category_id]) {
          this[property] = listStates[window.category_id][property]
        }
      }
    }
  },
  watch: {
    listState: function () {
      const listStates = JSON.parse(sessionStorage.getItem(listName))
      const newlistStates = {
        ...listStates,
        [window.category_id]: this.listState
      }
      sessionStorage.setItem(listName, JSON.stringify(newlistStates));
    },
  },
})

export default ListStateMixin
